import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import styles from './AddTestForm.module.css';

const AddTestForm = ({ show, onClose, onSuccess, editData }) => {
    const [testName, setTestName] = useState('');
    const [tat, setTat] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const isEditMode = Boolean(editData);

    useEffect(() => {
        if (editData) {
            setTestName(editData.TestName || '');
            setTat(editData.tat != null ? String(editData.tat) : '');
        } else {
            setTestName('');
            setTat('');
        }
    }, [editData, show]);

    if (!show) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!testName.trim()) {
            toast.error('Test Name is required');
            return;
        }

        setSubmitting(true);
        try {
            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };
            const body = { TestName: testName.trim(), tat: tat ? Number(tat) : null };

            if (isEditMode) {
                await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/api/testlist/${editData.id}`,
                    body,
                    { headers }
                );
                toast.success('Test updated successfully');
            } else {
                await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/testlist`,
                    body,
                    { headers }
                );
                toast.success('Test added successfully');
            }

            setTestName('');
            setTat('');
            if (onSuccess) onSuccess();
            onClose();
        } catch (err) {
            const status = err.response?.status;
            if (status === 400) {
                toast.error('Test Name is required');
            } else if (status === 409) {
                toast.error('Test already exists');
            } else {
                toast.error('Something went wrong. Please try again.');
            }
        } finally {
            setSubmitting(false);
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    return (
        <div className={styles.backdrop} onClick={handleBackdropClick}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        {isEditMode ? 'Edit Test' : 'Add New Test'}
                    </h3>
                    <button className={styles.closeBtn} onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={styles.modalBody}>
                        <div className={styles.field}>
                            <label htmlFor="testName">
                                Test Name <span className={styles.required}>*</span>
                            </label>
                            <input
                                id="testName"
                                type="text"
                                value={testName}
                                onChange={(e) => setTestName(e.target.value)}
                                placeholder="Enter test name"
                                required
                                disabled={submitting}
                            />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="tat">TAT (Days)</label>
                            <input
                                id="tat"
                                type="number"
                                min="0"
                                value={tat}
                                onChange={(e) => setTat(e.target.value)}
                                placeholder="e.g. 7"
                                disabled={submitting}
                            />
                        </div>
                    </div>
                    <div className={styles.modalFooter}>
                        <button
                            type="button"
                            className={styles.cancelBtn}
                            onClick={onClose}
                            disabled={submitting}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={styles.submitBtn}
                            disabled={submitting}
                        >
                            {submitting
                                ? (isEditMode ? 'Updating...' : 'Adding...')
                                : (isEditMode ? 'Update Test' : 'Add Test')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddTestForm;
